var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReplyAll = function SvgReplyAll(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.825 11 3.9 3.9q.3.3.287.7-.012.4-.312.7-.3.276-.7.287a.92.92 0 0 1-.7-.287l-4.6-4.6a.9.9 0 0 1-.213-.325A1.1 1.1 0 0 1 2.425 11q0-.2.062-.375A.9.9 0 0 1 2.7 10.3l4.6-4.6a.93.93 0 0 1 .687-.275q.413 0 .713.275.3.3.3.713 0 .412-.3.712zm6 1 2.9 2.9q.3.3.287.7-.012.4-.312.7-.3.276-.7.287a.92.92 0 0 1-.7-.287l-4.6-4.6a.9.9 0 0 1-.213-.325A1.1 1.1 0 0 1 7.425 11q0-.2.062-.375A.9.9 0 0 1 7.7 10.3l4.6-4.6a.93.93 0 0 1 .688-.275q.412 0 .712.275.3.3.3.713 0 .412-.3.712L10.825 10H17q2.075 0 3.538 1.463T22 15v3q0 .424-.288.712A.97.97 0 0 1 21 19a.97.97 0 0 1-.712-.288A.97.97 0 0 1 20 18v-3q0-1.25-.875-2.125A2.9 2.9 0 0 0 17 12z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReplyAll);
export { ForwardRef as ReactComponent };